import React from "react";
import { useState , useEffect} from "react";
import Loading from "../../general/Loading";
import { useClasseContext } from "../../../context/ClasseContext";
import { CheckCircle, XCircle, BarChart3, Eye, EyeOff } from "lucide-react";
import TrueFalseTableElement from "../BilanEval/FormBilanEval/FormQuestion/Elements/TrueFalseTableElement";
import RichTextBlockEleve from "../../VueQuestion/RichTextBlockEleve";
import ZoomableMedia from "../../VueQuestion/ZoomableMedia";
import { detectQuestionType, getTableElementConfig } from "../../../utils/questionUtils";
import { DistributionQCM, DistributionComplex, DistributionTexteLibre, DistributionRelier, DistributionOrdonner, DistributionTexteTrou, DistributionClasser } from "./ResultatParItem/DistributionRenderers";
import ResultatEvalNatByEleve from "./ResultatEvalNatByEleve";

function ResultatParItem({itemDetail, testSpecifique,bilan, AutomatismeQuestions, ProblèmesQuestions,
  LexiqueQuestion , CompetencesLangagieresQuestion, ComprehensionEcritQuestion, EvalNat, onEleveClick}) {
  const {classeNom} = useClasseContext();
  const [expandedAnswers, setExpandedAnswers] = useState({});
  const [selectedEleve, setSelectedEleve] = useState(null);
  const [showEleveModal, setShowEleveModal] = useState(false);

  // Fonction pour ouvrir le modal avec les données de l'élève
  const handleEleveClick = (eleveNom, classeNomEleve) => {
    // Si callback externe fourni (ex: AcquisEvalBilan), l'utiliser
    if (onEleveClick) {
      onEleveClick(eleveNom, classeNomEleve);
      return;
    }

    // Sinon comportement normal
    if (!EvalNat?.eleves_reponses) return;

    // Trouver l'élève dans EvalNat.eleves_reponses
    const eleveData = EvalNat.eleves_reponses.find(e => e.nom_eleve === eleveNom && e.classe_nom === classeNomEleve);
    if (eleveData) {
      setSelectedEleve(eleveData);
      setShowEleveModal(true);
    }
  };

  const closeEleveModal = () => {
    setShowEleveModal(false);
    setSelectedEleve(null);
  };

  useEffect(() => {
    setExpandedAnswers({});
  }, [itemDetail]);

  const toggleExpand = (key) => {
    setExpandedAnswers(prev => ({ ...prev, [key]: !prev[key] }));
  };

  if (!itemDetail) {
    return <Loading loadingText={"Chargement des détails..."} />;
  }


 

    const isObjectEmpty = (obj) => Object.keys(obj).length === 0;
    const hasItemDetail = itemDetail && !isObjectEmpty(itemDetail)




  if(  !(AutomatismeQuestions && ProblèmesQuestions && LexiqueQuestion && CompetencesLangagieresQuestion && ComprehensionEcritQuestion) ){
    return <Loading loadingText={"Chargement..."}/>
  }
  else {
      let index = undefined;
  
  // Créer un mapping des questions selon le testSpecifique
  const questionsMap = {
    'Automatismes': AutomatismeQuestions,
    'Problèmes': ProblèmesQuestions,
    'Lexique': LexiqueQuestion,
    'CompetencesLangagieres': CompetencesLangagieresQuestion,
    'ComprehensionEcrite': ComprehensionEcritQuestion
  };


  const questions = questionsMap[testSpecifique];

  if (!questions) {
    return null;
  }
  

// Recherche d'index simplifiée
if (bilan) {
  if (itemDetail && itemDetail.id) {
    index = questions[itemDetail.id];
  } else {
   index = questions[itemDetail.category ? 
    (itemDetail.category +' '+ itemDetail.question_num) : itemDetail.question_num];
  }
} else {
  // Pour tous les cas d'évaluation nationale
  // itemDetail.question sera soit "Q1" pour Automatismes/Problèmes
  // soit "Arachné Q1" pour ComprehensionEcrite
  index = questions[itemDetail.question];
}

// Vérification défensive : si index est undefined, ne rien afficher
if(!index) {
  if (bilan) {
    return <div> La question a été supprimée.</div>
  }
  // Pour évaluation nationale, retourner null si pas de détails sélectionnés
  return null;
}
  



  const totalStudents = hasItemDetail ? itemDetail.reussites.length + itemDetail.echecs.length : 0;
  const isBilan = !!itemDetail.id;
  const successCount = hasItemDetail ? itemDetail.reussites.length : 0;
  const failCount = hasItemDetail ? itemDetail.echecs.length : 0;

   return (
    <div className={`bg-white rounded-b-2xl border ${isBilan ? 'border-blue-200' : 'border-blue-100'} overflow-hidden w-full h-full shadow-sm`}>
      {/* Header discret uniforme avec Questions */}
      <div className="px-4 xl:px-3 2xl:px-3.5 3xl:px-4 py-3 xl:py-2 2xl:py-2.5 3xl:py-3 border-b border-gray-100 flex items-center justify-between">
        <div className="flex items-center gap-2 xl:gap-1.5 2xl:gap-1.5 3xl:gap-2">
          <BarChart3 className={`w-5 h-5 xl:w-4 xl:h-4 2xl:w-[18px] 2xl:h-[18px] 3xl:w-5 3xl:h-5 ${isBilan ? 'text-orange-500' : 'text-blue-600'}`} />
          <div>
            <h3 className="font-semibold text-gray-800 text-sm xl:text-xs 2xl:text-xs 3xl:text-sm">{isBilan ? 'Évaluation Bilan' : 'Évaluation Nationale'}</h3>
            <p className="text-[10px] xl:text-[9px] 2xl:text-[10px] text-gray-400">Cliquez sur "Tout voir" pour la répartition</p>
          </div>
        </div>
        {hasItemDetail && (
          <span className={`text-lg xl:text-base 2xl:text-lg font-bold ${isBilan ? 'text-orange-500' : 'text-blue-600'}`}>
            {totalStudents > 0 ? ((successCount / totalStudents) * 100).toFixed(0) : 0}%
          </span>
        )}
      </div>

      {hasItemDetail && (
        <div className="p-5 xl:p-3 2xl:p-4 3xl:p-5 space-y-4 xl:space-y-3 2xl:space-y-3.5 3xl:space-y-4">
          {/* Question */}
          <div className="bg-white rounded-xl p-4 xl:p-3 2xl:p-3.5 3xl:p-4 border border-blue-100 shadow-sm">
            <ImageWithLoading index={index} itemDetail={itemDetail} />
          </div>

          {/* Stats réussite/échec */}
          <div className="flex gap-3 xl:gap-2 2xl:gap-2.5 3xl:gap-3">
            <div className="flex-1 bg-emerald-50 rounded-xl p-3 xl:p-2 2xl:p-2.5 3xl:p-3 text-center border border-emerald-100">
              <div className="flex items-center justify-center gap-1 text-emerald-600 mb-1">
                <CheckCircle className="w-4 h-4 xl:w-3.5 xl:h-3.5 2xl:w-3.5 2xl:h-3.5 3xl:w-4 3xl:h-4" />
                <span className="font-bold xl:text-sm 2xl:text-sm 3xl:text-base">{successCount}</span>
              </div>
              <p className="text-xs xl:text-[10px] 2xl:text-[11px] 3xl:text-xs text-gray-500">Réussites</p>
            </div>
            <div className="flex-1 bg-orange-50 rounded-xl p-3 xl:p-2 2xl:p-2.5 3xl:p-3 text-center border border-orange-100">
              <div className="flex items-center justify-center gap-1 text-orange-500 mb-1">
                <XCircle className="w-4 h-4 xl:w-3.5 xl:h-3.5 2xl:w-3.5 2xl:h-3.5 3xl:w-4 3xl:h-4" />
                <span className="font-bold xl:text-sm 2xl:text-sm 3xl:text-base">{failCount}</span>
              </div>
              <p className="text-xs xl:text-[10px] 2xl:text-[11px] 3xl:text-xs text-gray-500">Échecs</p>
            </div>
          </div>

          {/* Répartition des réponses */}
          <div className="space-y-2 xl:space-y-1.5 2xl:space-y-1.5 3xl:space-y-2">
            <div className="flex items-center justify-between">
              <p className="text-sm xl:text-xs 2xl:text-xs 3xl:text-sm text-gray-500 font-medium">Répartition des réponses</p>
              <button
                onClick={() => {
                  // Toggle : si des panneaux sont ouverts → tout fermer, sinon → tout ouvrir
                  if (Object.keys(expandedAnswers).length > 0) {
                    setExpandedAnswers({});
                  } else {
                    // Ouvrir tous les panneaux existants (les composants Distribution utilisent des clés type-N)
                    const allEleves = [...itemDetail.reussites, ...itemDetail.echecs];
                    const keys = {};
                    allEleves.forEach((_, i) => { keys[`all-${i}`] = true; });
                    // Générer suffisamment de clés pour couvrir tous les groupes possibles
                    for (let i = 0; i < 50; i++) {
                      ['simple', 'complex', 'texte', 'relier', 'ordonner', 'trou', 'classer'].forEach(prefix => {
                        keys[`${prefix}-${i}`] = true;
                      });
                    }
                    setExpandedAnswers(keys);
                  }
                }}
                className={`flex items-center gap-1.5 xl:gap-1 2xl:gap-1 3xl:gap-1.5 px-3 xl:px-2 2xl:px-2.5 3xl:px-3 py-1.5 xl:py-1 2xl:py-1 3xl:py-1.5 rounded-lg text-xs xl:text-[10px] 2xl:text-[11px] 3xl:text-xs font-medium transition-all duration-200 ${
                  Object.keys(expandedAnswers).length > 0
                    ? 'bg-orange-500 text-white hover:bg-orange-600'
                    : 'bg-blue-50 text-blue-600 hover:bg-blue-100'
                }`}
              >
                {Object.keys(expandedAnswers).length > 0 ? <EyeOff className="w-3.5 h-3.5 xl:w-3 xl:h-3 2xl:w-3 2xl:h-3 3xl:w-3.5 3xl:h-3.5" /> : <Eye className="w-3.5 h-3.5 xl:w-3 xl:h-3 2xl:w-3 2xl:h-3 3xl:w-3.5 3xl:h-3.5" />}
                {Object.keys(expandedAnswers).length > 0 ? 'Tout masquer' : 'Tout voir'}
              </button>
            </div>

            {/* Routing par type de question vers le bon renderer de distribution */}
            {(() => {
              const questionType = detectQuestionType(index);
              const commonProps = { index, itemDetail, expandedAnswers, toggleExpand, totalStudents, handleEleveClick, bilan, onEleveClick, classeNom };

              if (questionType === 'complex') return <DistributionComplex {...commonProps} />;
              if (questionType === 'texte') return <DistributionTexteLibre {...commonProps} />;
              if (questionType === 'relier') return <DistributionRelier {...commonProps} />;
              if (questionType === 'ordonner') return <DistributionOrdonner {...commonProps} />;
              if (questionType === 'texte_trou') return <DistributionTexteTrou {...commonProps} />;
              if (questionType === 'classer') return <DistributionClasser {...commonProps} />;
              return <DistributionQCM {...commonProps} />;
            })()}
          </div>
        </div>
      )}

      {/* Modal détail élève */}
      <ResultatEvalNatByEleve
        show={showEleveModal}
        onClose={closeEleveModal}
        eleve={selectedEleve}
        EvalNat={EvalNat}
      />
    </div>
    )
}
}
function ImageWithLoading({ index, itemDetail }) {

  // L'image chargée, retenue par son adresse : le chargement se DÉDUIT de l'adresse affichée. Aucun effet ne le
  // remet à zéro après coup, donc une image déjà en cache ne reste jamais cachée.
  const [imageChargee, setImageChargee] = useState(null);
  const enChargement = Boolean(index.image) && imageChargee !== index.image;
  const marquerChargee = (e) => setImageChargee(e.currentTarget.getAttribute('src'));

  return (
       <>
      {index.image ? (
        // La capture d'énoncé, comme les images des exerciseurs : jamais plus large que le panneau, hauteur
        // bornée à 40 % de l'écran, et un clic l'agrandit à la plus grande taille qui tient dans l'écran
        // (ZoomableMedia, zoomFit.js).
        <div className="relative flex items-center justify-center  w-full bg-gray-50 rounded mb-4 xl:mb-3 2xl:mb-3.5 3xl:mb-4 overflow-hidden">
          {enChargement ? (
            <div className="flex items-center justify-center py-6">
              <div className="w-6 h-6 border-2 border-blue-500 border-t-transparent rounded-full animate-spin" />
            </div>
          ) : null}
          <ZoomableMedia
            type="image"
            src={`${index.image}`}
            alt={`Question ${itemDetail.question}`}
            className="max-w-full"
            imgClassName={`${enChargement ? 'hidden' : 'block'} max-w-full h-auto max-h-[40vh] object-contain p-2 xl:p-1.5 2xl:p-1.5 3xl:p-2`}
            onLoad={marquerChargee}
            onError={marquerChargee}
          />
        </div>
      ) : (
        // Énoncé en texte (questions nationales saisies sans capture : Volcans, 4e Q01 et Q06) : la police
        // de l'énoncé des exerciseurs (Fredoka), comme dans le quiz élève, au lieu de celle de l'interface.
        <div className="mb-4 xl:mb-3 2xl:mb-3.5 3xl:mb-4 text-sm xl:text-xs 2xl:text-xs 3xl:text-sm font-['Fredoka',sans-serif] font-medium">
          <RichTextBlockEleve texte={index.question} elements={index.elements_additionnels} theme="light" />
          {/* Tableau (vrai/faux, association, colonnes libres) — affiché séparément de l'énoncé */}
          {getTableElementConfig(index) && (
            <div className="mt-3 xl:mt-2 2xl:mt-2.5 3xl:mt-3">
              <TrueFalseTableElement config={getTableElementConfig(index)} isPreview compact />
            </div>
          )}
        </div>
      )}
    </>
  );
}


export default ResultatParItem;


